import { motion } from "framer-motion";
import { Buildings, Star, ShieldCheck } from "@phosphor-icons/react";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
};

const stats = [
  { icon: Buildings, value: "1+1 & 2+0", label: "Full Eşyalı Daireler" },
  { icon: Star, value: "5", label: "Yıldız Standart" },
  { icon: ShieldCheck, value: "7/24", label: "Güvenlik" },
];

const About = () => {
  return (
    <section
      id="hakkimizda"
      data-testid="about-section"
      className="section-padding bg-[#F9F6F0]"
    >
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <motion.div {...fadeUp}>
            <span className="overline mb-4 inline-block">Tesis Hakkında</span>
            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-[#1A1A1A] mb-6">
              Mardin'de Ayrıcalıklı{" "}
              <span className="text-[#4A5D23]">Yaşam</span>
            </h2>
            <p className="font-['Outfit'] text-base sm:text-lg text-[#4A4A4A] leading-relaxed mb-6">
              Mardin'de apart otel konforunu 5 yıldızlı standartlarda sunan DVT Rezidans, 
              özellikle aileler ve memurlar için özenle tasarlanmış modern bir konaklama tesisidir. 
              Tesisimizde yer alan tüm daireler 1+1 ve 2+0 konseptinde olup, tamamen sıfır ve full eşyalı 
              olarak hizmet vermektedir.
            </p>
            <p className="font-['Outfit'] text-base sm:text-lg text-[#4A4A4A] leading-relaxed mb-8">
              Konforun ön planda tutulduğu rezidansımızda yerden ısıtma sistemi, her odada bulunan 
              multi klima altyapısı ve ferah, manzaralı yaşam alanları ile dört mevsim rahat bir 
              konaklama imkanı sunulmaktadır.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, i) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.5 }}
                  className="text-center p-4 rounded-2xl bg-[#EFEAE2] border border-[#D1C9B8]/30"
                >
                  <stat.icon size={28} weight="duotone" className="text-[#4A5D23] mx-auto mb-2" />
                  <div className="font-['Playfair_Display'] text-xl sm:text-2xl font-bold text-[#1A1A1A]">
                    {stat.value}
                  </div>
                  <div className="font-['Outfit'] text-xs sm:text-sm text-[#4A4A4A] mt-1">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="img-zoom rounded-2xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1738168246881-40f35f8aba0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzYwNDQ2NDZ8MA&ixlib=rb-4.1.0&q=85"
                alt="DVT Rezidans iç mekan"
                className="w-full h-[400px] sm:h-[500px] lg:h-[600px] object-cover"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-4 sm:left-6 glass-surface rounded-2xl px-6 py-4 shadow-lg">
              <div className="font-['Outfit'] text-xs text-[#4A5D23] font-semibold tracking-wider uppercase mb-1">
                Komisyon
              </div>
              <div className="font-['Playfair_Display'] text-xl sm:text-2xl font-bold text-[#1A1A1A]">
                %0
              </div>
              <div className="font-['Outfit'] text-sm text-[#4A4A4A]">
                Emlakçı komisyonu yok
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
